<template>
    <v-container
        fluid
        style="min-height: 0;"
    >
        <v-tabs
            fixed
            centered
            v-model="filter"
        >
            <v-tabs-bar class="grey lighten-5">
                <v-tabs-slider class="amber"></v-tabs-slider>
                <v-tabs-item
                    ripple
                    v-for="tab in tabs"
                    :key="tab"
                    :href="'#' + tab"
                >
                    {{ tab }}
                </v-tabs-item>
            </v-tabs-bar>

        </v-tabs>

        <div v-if="consents.length === 0" class="text-xs-center pt-2 pb-2 grey--text text--darken-1">No results</div>

        <template v-else>
            <v-layout row>
                <v-flex xs12>
                    <v-card v-if="consents && consents.length > 0">
                        <v-list
                            three-line
                        >
                            <v-list-tile
                                avatar
                                ripple
                                v-for="(item, index) in consents"
                                :key="key(item)"
                                @click="details(item, index)"
                            >
                                <v-list-tile-avatar>
                                    <v-icon :class="item.Status">fa-code-fork</v-icon>
                                </v-list-tile-avatar>

                                <v-list-tile-content>
                                    <v-list-tile-title class="bold">{{ item.DataOwnerCode }}</v-list-tile-title>
                                    <v-list-tile-title>{{ item.Intent.ShortDescription }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ userReadable(item.Expiration) }}</v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile-action>
                                    <v-icon class="visible-hover">mode_edit</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </v-card>
                </v-flex>
            </v-layout>
        </template>
    </v-container>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'FilteredConsentsList',
        props: {
            consents: { type: Array, required: true },
        },
        data() {
            return {
                tabs: ['all', 'granted', 'revoked'],
                active_tab: 'all',
            };
        },
        computed: {
            filter: {
                get() {
                    return this.active_tab;
                },
                set(filter) {
                    this.$emit('filter', filter);
                },
            },
        },
        methods: {
            key(consent) {
                return `${consent.IntentIssuerCode}_${consent.IntentCode}_${consent.DataOwnerCode}`;
            },
            userReadable(date) {
                return moment(date).format('LLL');
            },
            details(item) {
                this.$router.push({ path: `/consents/${item.IntentIssuerCode}/${item.IntentCode}/${item.DataOwnerCode}` });
            },
        },
        created() {
        },
    };
</script>

<style scoped lang="stylus">
    @import '../../node_modules/vuetify/src/stylus/theme'

    .list
        &__tile
            .bold
                font-weight: bold

            .visible-hover
                visibility: hidden

        :hover
            .visible-hover
                visibility: visible

    .granted
        color: $theme.success
    .expired
        color: $theme.warning
    .revoked
        color: $theme.error
</style>



// WEBPACK FOOTER //
// FilteredConsentsList.vue?62c44c82